import * as XLSX from 'xlsx';

export const exportReservationExcel = (filteredFactures) => {

    console.log("filteredFactures",filteredFactures);
    const toExcelDate = (date) => {
        if (!(date instanceof Date)) return null;
        const excelEpoch = new Date(Date.UTC(1899, 11, 30));
        return Math.floor((date - excelEpoch) / (1000 * 60 * 60 * 24));
    };
    const exportData = filteredFactures.flatMap((reservation) => {
        const { clients } = reservation;
        const numberOfClients = clients.length;
        return clients.map((client, clientIndex) => {
            const Statut = client.reservationStatus;
            const BC_Réf = client.BCReference;
            const تاريخ_الخروج = toExcelDate(new Date(client.checkOutDate));
            const تاريخ_الدخول = toExcelDate(new Date(client.checkInDate));
            const  اسم_الحريف = client.clientName;
            const جواز_السفر = client.passport; 
            const ملاحظة = reservation.observation;
            const الاقامة = reservation.pension;
            const الغرفة = reservation.selectedRoom;
            const النزل = reservation.selectedHotel;
            const المؤسسة = reservation.selectedorganisme;
            const معرف_الحجز = reservation.id_reservation;
            const التاريخ = toExcelDate(new Date(reservation.currentDate));
            return {
                Statut,
                BC_Réf,
                تاريخ_الخروج,
                تاريخ_الدخول,
                اسم_الحريف,
                جواز_السفر,
                ملاحظة,
                الاقامة,
                الغرفة,
                النزل,
                المؤسسة,
                معرف_الحجز,
                التاريخ,
            };
        });
    });

    const ws = XLSX.utils.json_to_sheet(exportData);
    const dateColumns = ['C', 'D', 'M'];
    dateColumns.forEach((column) => {
        for (let i = 1; i <= exportData.length; i++) {
            const cellAddress = XLSX.utils.encode_cell({ r: i, c: column.charCodeAt(0) - 65 });
            if (ws[cellAddress]) {
                ws[cellAddress].z = 'dd/mm/yyyy'; 
            }
        }
    });
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "قائمة العملاء");
    XLSX.writeFile(wb, "قائمة العملاء.xlsx");
};
